import "@gamedev-web/gamedev-sdk-core/build/styles/glyphs.css";

import cx from "classnames";

export enum GlyphPlacement {
  Prepend = "prepend",
  Append = "append",
}

export enum GlyphIcon {
  Accept = "accept",
  Add = "add",
  AddFriend = "addfriend",
  Back = "back",
  Cellphone = "cellphone",
  Cancel = "cancel",
  Checkbox = "checkbox",
  CheckboxComposite = "checkbox-composite",
  CheckBoxIndeterminate = "checkbox-indeterminate",
  CheckMark = "check-mark",
  ChevronDown = "chevron-down",
  ChevronLeft = "chevron-left",
  ChevronRight = "chevron-right",
  ChevronUp = "chevron-up",
  CirclePlus = "circle-plus",
  Clear = "clear",
  Edit = "edit",
  Devices2 = "devices2",
  Devices3 = "devices3",
  Download = "download",
  FavoriteStar = "favorite-star",
  FavoriteStarFill = "favorite-star-fill",
  Forward = "forward",
  GamepassUltimateInline2 = "game-pass-ultimate-inline2",
  GlobalNavButton = "global-nav-button",
  Heart = "heart",
  Hololens = "hololens",
  Hololens2 = "hololens2",
  IndicatorDotFilled = "indicator-dot-filled",
  IndicatorDotOutline = "indicator-dot-outline",
  Info = "info",
  LeftDoubleQuote = "left-double-quote",
  Lock = "lock",
  MobileTablet = "mobile-tablet",
  More = "more",
  OutlineHalfStarLeft = "outline-half-star-left",
  Pc1 = "pc1",
  PhotoCollection = "photo-collection",
  Play = "play",
  PlayButton = "play-button",
  PlayButtonLarge = "play-button-large",
  RemoveFrom = "remove-from",
  RightDoubleQuote = "right-double-quote",
  LeftNavButton = "left-nav-button",
  RightNavButton = "right-nav-button",
  Refresh = "refresh",
  Search = "search",
  Settings = "settings",
  Share = "share",
  ShoppingCart = "shopping-cart",
  System = "system",
  TvMonitor = "tv-monitor",
  UbisoftPlus = "ubisoft-plus",
  Unknown = "unknown",
  Up = "up",
  View = "view",
  Warning = "warning",
  World = "world",
  XboxController = "xbox-controller",
  XboxGamepassInline = "xbox-game-pass-inline",
  XboxGoldInline = "xbox-gold-inline",
  XboxOneConsole = "xbox-one-console",
  XboxLogo = "xbox-logo",
}

export const getGlyphClassNames = (placement: GlyphPlacement, icon: GlyphIcon): string =>
  cx([`glyph-${placement}`, `glyph-${placement}-${icon}`]);
